export const SET_LANG = 'SET_LANG';
export const SET_THEME = 'SET_THEME';
export const SET_MODAL = 'SET_MODAL';